/**
 * Converts degrees to radians.
 * @param deg Degrees.
 * @returns Radians.
 */
export function degToRad(deg: number): number {
  return (deg * Math.PI) / 180;
}
